import { getValueOrField } from '../../utils';
import type {
    Duration,
    DurationType,
    Easing,
    EasingType,
    VariantsKeys,
    VariantsType,
    CollapseProps,
} from '../../types';
import { DURATION, EASING } from '../../constants';

const isNumeric = (value: any) => value !== null && parseInt(value.toString(), 10) > 0;

const getTransition = (
    variant: VariantsKeys,
    duration: DurationType = 'moderate1',
    easing: EasingType = 'easeInOut',
    delay?: DurationType
) => ({
    duration: DURATION[getValueOrField(duration, variant) as Duration],
    ease: EASING[getValueOrField(easing, variant) as Easing],
    delay: DURATION[getValueOrField(delay, variant) as Duration],
});

const variants: VariantsType<CollapseProps> = {
    enter: ({ endingHeight, delay, duration, easing }) => ({
        opacity: [1],
        height: [endingHeight],
        timing: getTransition('enter', duration, easing, delay),
        isFirstRender: 1,
    }),
    start: ({ endingHeight, delay, duration, easing }) => ({
        opacity: [1],
        height: [endingHeight],
        timing: getTransition('enter', duration, easing, delay),
        isFirstRender: 0,
    }),
    exit: ({ animateOpacity, startingHeight, delay, duration, easing }) => ({
        ...(animateOpacity && {
            opacity: isNumeric(startingHeight) ? [1] : [0],
        }),
        height: [startingHeight],
        timing: getTransition('exit', duration, easing, delay),
    }),
};

export default variants;
